import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const Row = styled.div`
  flex-wrap: wrap;
`;

export const RowItem = styled.div`
  width: 50%;
  margin: 0 !important;
  padding-inline-end: 1rem;
  @media (max-width: ${({ theme }) => theme.media.sm}) {
    margin: 5px 0px !important;
  }
`;

export const SingleTicketItemKey = styled.p`
  font-size: ${({ theme }) => theme.fs.xxs};
  color: ${({ theme }) => theme.palette.secondary};
  margin-bottom: ${({ theme }) => theme.spacing.x1};
`;
export const SingleTicketItemValue = styled.p`
  font-size: ${({ theme }) => theme.fs.xs};
  font-weight: 500;
  white-space: nowrap;
  width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const SingleChatBoxWrapper = styled.div`
  flex: 1;
  direction: rtl;
  border-radius: ${({ theme }) => theme.spacing.x4} !important;
`;
